/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionVisibilityResponse } from './CompetitionVisibilityResponse';
import {
    CompetitionVisibilityResponseFromJSON,
    CompetitionVisibilityResponseFromJSONTyped,
    CompetitionVisibilityResponseToJSON,
    CompetitionVisibilityResponseToJSONTyped,
} from './CompetitionVisibilityResponse';

/**
 * 
 * @export
 * @interface GetCompetitionVisibilityResponse
 */
export interface GetCompetitionVisibilityResponse {
    /**
     * 
     * @type {Array<CompetitionVisibilityResponse>}
     * @memberof GetCompetitionVisibilityResponse
     */
    visibility?: Array<CompetitionVisibilityResponse>;
    /**
     * Server timestamp for cache debugging
     * @type {number}
     * @memberof GetCompetitionVisibilityResponse
     */
    timestamp?: number;
}

/**
 * Check if a given object implements the GetCompetitionVisibilityResponse interface.
 */
export function instanceOfGetCompetitionVisibilityResponse(value: object): value is GetCompetitionVisibilityResponse {
    return true;
}

export function GetCompetitionVisibilityResponseFromJSON(json: any): GetCompetitionVisibilityResponse {
    return GetCompetitionVisibilityResponseFromJSONTyped(json, false);
}

export function GetCompetitionVisibilityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCompetitionVisibilityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'visibility': json['visibility'] == null ? undefined : ((json['visibility'] as Array<any>).map(CompetitionVisibilityResponseFromJSON)),
        'timestamp': json['timestamp'] == null ? undefined : json['timestamp'],
    };
}

export function GetCompetitionVisibilityResponseToJSON(json: any): GetCompetitionVisibilityResponse {
    return GetCompetitionVisibilityResponseToJSONTyped(json, false);
}

export function GetCompetitionVisibilityResponseToJSONTyped(value?: GetCompetitionVisibilityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'visibility': value['visibility'] == null ? undefined : ((value['visibility'] as Array<any>).map(CompetitionVisibilityResponseToJSON)),
        'timestamp': value['timestamp'],
    };
}

